import React, { ReactElement, FC } from 'react'
import { Button } from 'antd'
import { s } from './style'

type ButtonProps = React.ComponentProps<typeof Button>

export const HeavyOutlineButton: FC<ButtonProps> = ({ children, style, ...rest }): ReactElement => (
  <Button style={{ ...style, ...s.button }} {...rest}>
    {children}
  </Button>
)
